import {defineStore} from "pinia";
import {
    useAddProjectTypes,
    useDeleteProjectTypes,
    useProjectTypesList,
    useUpdateProjectTypes
} from "../composables/project";
import {NewProjectType, ProjectType, UpdateProjectType} from "../models/project";
import {MaybeComputedRef, useStorage} from "@vueuse/core";
import {useUserStore} from "./user";
import {computed} from "vue";

export const useProjectTypesStore = defineStore('projectTypes', () => {
    const {
        data: projectTypes,
        execute
    } = useProjectTypesList()

    const userStore = useUserStore()


    const userProjectTypes = useStorage<Map<string, ProjectType>>('projectType', new Map())

    const selectedProjectType = computed(() => userProjectTypes.value.get(userStore.user.username))

    async function add(projectType: NewProjectType) {
        await useAddProjectTypes(projectType)
        await execute()
    }

    async function deleteType(id: MaybeComputedRef<number>) {
        await useDeleteProjectTypes(id)
        await execute()
    }

    async function updateType(id: MaybeComputedRef<number>, projectType: UpdateProjectType) {
        await useUpdateProjectTypes(id, projectType)
        await execute()
    }

    async function fetch() {
        await execute()
    }

    async function select(projectType: ProjectType | null) {
        userProjectTypes.value = userProjectTypes.value.set(userStore.user.username, projectType)
    }

    return {projectTypes, selectedProjectType, select, deleteType, add, fetch, updateType}
})
